export default __webpack_public_path__ + "static/media/landing-bg-1.a22757a2.png";